import { LoadActiveSearchStatistics } from 'domain/usecases/active-search/load-active-search-statistics'
import { LoadActiveSearchType } from 'domain/usecases/active-search/load-active-search-type'
import { RepositoryErrors } from 'repository/errors/repository-errors'
import handleGraphQLError from 'repository/graphql/utils/handle-error'
import { IActiveSearchRepository } from 'repository/interfaces/active-search-repository'
import { ApiStatusCode } from 'service/protocols/api/api-client'
import { IApiRepository } from 'service/protocols/api/api-repository'

export class ActiveSearchRepository implements IActiveSearchRepository {
  constructor(private readonly apiRepository: IApiRepository) {}

  async loadActiveSearchStatistics(
    params?: LoadActiveSearchStatistics.Params
  ): Promise<LoadActiveSearchStatistics.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<LoadActiveSearchStatistics>

    const httpResponse: any = await apiRepository.get({
      url: '/active-searchers/statistics',
      params: params
    })

    if (
      httpResponse.statusCode &&
      httpResponse.statusCode !== ApiStatusCode.ok
    ) {
      throw handleGraphQLError(
        RepositoryErrors[httpResponse.error as keyof typeof RepositoryErrors]
      )
    } else {
      return httpResponse.body.data as LoadActiveSearchStatistics.Model
    }
  }

  async loadActiveSearchType(
    params: LoadActiveSearchType.Params
  ): Promise<LoadActiveSearchType.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<LoadActiveSearchType>

    const httpResponse: any = await apiRepository.get({
      url: '/active-searchers',
      params: params
    })

    if (
      httpResponse.statusCode &&
      httpResponse.statusCode !== ApiStatusCode.ok
    ) {
      throw handleGraphQLError(
        RepositoryErrors[httpResponse.error as keyof typeof RepositoryErrors]
      )
    } else {
      return httpResponse.body.data as LoadActiveSearchType.Model
    }
  }
}
